import P from '../../pages';
import Register from '../ui/Register';
import { connect } from 'react-redux';
import { registerUser, backToAddress, setPage } from '../../actions';

const mapStateToProps = (state, props) =>
  ({
    page: state.page,
    intl: props.intl,
    content: state.content,
    marketing_referrers: state.territory.host_marketing_referrers,
    marital_statuses: state.territory.marital_statuses,
    country_code: state.territory.country_code,
    environment: state.environment,
    transaction_email: state.territory.transaction_email,
    territory_code: state.territory.code,
    generateDetailsEnabled: state.territory.generate_details_enabled,
    showGenderField: state.territory.show_host_gender_field,
    criticalContracts: state.territory.host_critical_contracts,
    requiredFields: state.requiredFields,
    address: state.address,
    addressValidations: state.addressValidations,
    recaptchaSiteId: state.recaptchaSiteId,
    firebaseEnabled: state.territory.enable_firebase_authentication
  });

const mapDispatchToProps = dispatch =>
  ({
    onRegisterUser(payload) {
      dispatch(
        registerUser(payload)
      );
    },
    onGoBack(){
      dispatch(backToAddress())
    },
    redirectToFirebaseLogin(payload) {
       dispatch(
         setPage(P.FIREBASE_REGISTER_PAGE)
       );
    },
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(Register);

export default Container;
